import type { FilingFormState } from '../services/mbrs/filing-form-state.service';

/**
 * Canonical sheet-key constants — the single source of truth for the string keys
 * that address a sheet's slice of `FilingFormState` (state service,
 * MappingStatusService, dependency graph, …). Prefer these over hardcoded string
 * literals so renames are compile-checked in one place and call sites read intent
 * instead of magic strings.
 *
 * Each value is a `keyof FilingFormState` (enforced by `satisfies`), so a typo here
 * is a compile error and consumers receive a value typed as that exact key.
 */
export const SHEET_KEYS = {
  filingPrerequisites: 'filingPrerequisites',
  filingInfo: 'filingInfo',
  scopeOfFiling: 'scopeOfFiling',
  stockExchangeDisclosure: 'stockExchangeDisclosure',
  directorsReport: 'directorsReport',
  statementByDirectors: 'statementByDirectors',
  directorBusinessReview: 'directorBusinessReview',
  auditorsReport: 'auditorsReport',
  statementOfFinancialPosition: 'statementOfFinancialPosition',
  subClassificationOfAssetsLiabilitiesEquity: 'subClassificationOfAssetsLiabilitiesEquity',
  statementOfFinancialPositionLiquidity: 'statementOfFinancialPositionLiquidity',
  subClassificationLiquidity: 'subClassificationLiquidity',
  statementOfProfitOrLoss: 'statementOfProfitOrLoss',
  analysisOfProfitOrLoss: 'analysisOfProfitOrLoss',
  statementOfProfitOrLossByNature: 'statementOfProfitOrLossByNature',
  analysisOfProfitOrLossByNature: 'analysisOfProfitOrLossByNature',
  statementOfComprehensiveIncome: 'statementOfComprehensiveIncome',
  statementOfComprehensiveIncomeBeforeTax: 'statementOfComprehensiveIncomeBeforeTax',
  statementOfCashFlowsDirectMethod: 'statementOfCashFlowsDirectMethod',
  statementOfCashFlowsIndirectMethod: 'statementOfCashFlowsIndirectMethod',
  statementOfChangesInEquity: 'statementOfChangesInEquity',
  notesCorporateInformation: 'notesCorporateInformation',
  notesAccountingPolicies: 'notesAccountingPolicies',
  notesListOfNotes: 'notesListOfNotes',
  notesIssuedCapital: 'notesIssuedCapital',
  notesRelatedPartyTransactions: 'notesRelatedPartyTransactions',
} as const satisfies Record<string, keyof FilingFormState>;
